import '@/app/app.css';
import './cart.css';

import '@/app/app';
import html2pdf from 'html2pdf.js';

import { OrderApplication } from '@/components/order-vue/application';

window.app.OrderApplication = OrderApplication;
window.app.html2pdf = html2pdf;

window.addEventListener('load', () => {
	
	/* Download cart to PDF */

	/*
	const cartPage = document.querySelector('.page');
	const pdfButton = document.querySelector('.js-save-cart-to-pdf');

	const pdf = new html2pdf();
	const pdfOptions = {
		filename: 'sov-obr-cart.pdf',
		margin: [10, 0],
		enableLinks: false,
		pagebreak: { mode: ['css'] },
		image: { type: 'png', quality: 1 },
		html2canvas: {
			scale: 2,
			onclone: function (doc) {
				doc.documentElement.querySelector('.page').classList.add('page--print');
			},
		},
		jsPDF: {
			format: 'A4',
		},
	};

	function downloadCartToPDF() {
		document.querySelector('.cart-items__list').scrollTo(0, 0);
		document.querySelector('.cart-items__list').style.maxHeight = 'fit-content';
		pdf.set(pdfOptions).from(cartPage).save();
		document.querySelector('.cart-items__list').style.removeProperty('max-height');
	}

	pdfButton?.addEventListener('click', downloadCartToPDF);
	*/
	/* Checkout form */
	/*
	const checkout = document.querySelector('.checkout-items.js-form');

	if (checkout) {
		const formInstance = app.classInstance.get(checkout)?.form;
		const commonTabs = checkout.querySelectorAll('.checkout-item:not(.checkout-options) .js-tabs__content');
		const optionsTabs = checkout.querySelectorAll('.checkout-options .js-tabs__content');
		const formFields = checkout.querySelectorAll('.checkout-item__form-group .js-form-element.required');
		const formButtons = checkout.querySelectorAll('.checkout-items__submit');

		commonTabs.forEach((tab) => {
			tab.addEventListener('tabShown', () => reinitFormFields(formFields, formInstance));
		});
		optionsTabs.forEach((tab) => {
			tab.addEventListener('tabClose', () => reinitCheckoutForm(formInstance, formButtons, tab));
		});

		disableHiddenFields(formFields, formInstance);
	}
	 */
});
/*
function reinitCheckoutForm(formInstance, submitButtons, currentTab) {
	submitButtons.forEach((button) => {
		button.type = 'button';
	});
	const submitButton = currentTab.querySelector('.checkout-items__submit');
	submitButton.type = 'submit';
	formInstance.reinit();
}

function reinitFormFields(formFields, formInstance) {
	formFields.forEach((field) => {
		const input = field.querySelector('input');

		if (field.closest('.js-tabs__content').classList.contains('tabs__content--active')) {
			input.required = true;
			input.dataset.look = true;
		} else {
			input.required = false;
			input.dataset.look = false;
		}
	});
	formInstance.reinit();
}

function disableHiddenFields(formFields, formInstance) {
	formFields.forEach((field) => {
		const input = field.querySelector('input');

		if (!field.closest('.js-tabs__content').classList.contains('tabs__content--active')) {
			input.required = false;
			input.dataset.look = false;
		}
	});
	formInstance.reinit();
}
*/
